import { useEffect, useState } from 'react';

/**
 * https://usehooks.com/useDebounce/
 * @param value
 * @param delay milliseconds to debounce
 * @returns value
 */
export const useDebounce = <Value>(value: Value, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};
